/**
 * Desktop page footer stays below the fold until the user scrolls
 * about one header-height down. It then stays visible until they
 * return to the top of the page.
 */
(function () {
  var footer = document.querySelector(".page-footer");
  if (!footer) {
    return;
  }

  var root = document.documentElement;
  var ticking = false;

  function triggerDistance() {
    var fromVar = parseFloat(
      getComputedStyle(root).getPropertyValue("--header-initial-height"),
    );
    if (fromVar) {
      return fromVar;
    }

    var header = document.getElementById("site-header");
    return header ? header.offsetHeight : 0;
  }

  function update() {
    footer.classList.toggle("is-revealed", window.scrollY > triggerDistance());
    ticking = false;
  }

  function onScroll() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(update);
  }

  update();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
})();
